import React from "react";
import { Helmet } from "react-helmet";

const ResponsiveHelmet = (props) => {
  const { allowedResponsive = false } = props;
  return (
    <Helmet>
      {
        allowedResponsive &&
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes" />
      }
      {
        !allowedResponsive &&
        <meta name="viewport" content="width=1170" />
      }
    </Helmet>
  );
}

export default ResponsiveHelmet;

